@if (!eventInfo) {
<div class="container-evento-nao-encontrado">
  <p class="h5 text-dark">Evento não encontrado</p>
</div>
} @else if (eventInfo) {
<div class="container">
  <div id="tickets-section" class="event-stage">
  <div class="event-header">
    <div class="event-banner-container">
      <div class="event__favorite" [class.event__favorite--finished]="eventDateHasPassed(eventInfo.end_date)">
        <button mat-icon-button (click)="handleFavoriteClick($event)">
          <mat-icon [class.animate-pulse]="isAnimatingFavorite">{{
            eventInfo.is_favorite ? "favorite" : "favorite_border"
            }}</mat-icon>
        </button>
      </div>

      <img class="event-banner" appImgFallback="./../../../../assets/images/evento-sem-imagem.svg" [src]="eventImage"
        alt="Imagem do evento" />
    </div>
    <div class="event-info">
      <h1 class="event-title">{{ eventInfo.title }}</h1>
      <div class="event-date">
        <p class="p">
          <i class="pi pi-calendar"></i> {{ eventInfo.start_date | date: "EEEE, dd 'de' MMMM 'de' yyyy" }}
        </p>
        <p class="small text-secondary">
          <i class="pi pi-clock"></i>
          {{ eventInfo.start_date | date: "shortTime" }} -
          {{ eventInfo.end_date | date: "shortTime" }}
        </p>
      </div>
      <div class="event-location">
        <p class="p" style="text-transform: uppercase">
          <i class="pi pi-map-marker"></i> {{ eventInfo.address.location_name }} - {{ eventInfo.address.city_name }},
          {{ eventInfo.address.state }}
        </p>
        <p class="small text-secondary">
          {{ eventInfo.address.street }}, {{ eventInfo.address.number }}, {{ eventInfo.address.district }},
          {{ eventInfo.address.city_name }} - {{ eventInfo.address.state }}
        </p>
      </div>
      @if (eventInfo.organizer_page) {
      <p class="p event-organizer">
        <i class="pi pi-user"></i> Organizado por
        <a class="event-organizer__link" [routerLink]="['/', eventInfo.organizer_page]">
          {{ eventInfo.organizer_name }}
        </a>
      </p>
      }
      <!-- <span class="event-description"><i class="fa fa-info-circle"></i> PARCELE SEUS INGRESSOS EM ATE 6X</span> -->
      <div class="share">
        <p class="p">Compartilhar</p>
        <div class="event-button">
          <app-button styleType="secondary" icon="pi pi-facebook" (click)="compartilharFacebook()">
            Facebook
          </app-button>
          <app-button styleType="outlined" icon="pi pi-whatsapp" (click)="compartilharWhatsapp()">
            Whatsapp
          </app-button>
          <app-button styleType="outlined" icon="pi pi-copy" (click)="copiarLink()">
            Copiar link
          </app-button>
          <!-- <app-button styleType="secondary" icon="pi pi-instagram" (click)="compartilharInstagram()">
                Instagram
              </app-button> -->
        </div>
      </div>
    </div>
  </div>
  @if (isFreePrivate) {
  <div class="event-tickets">
    <div class="card-tickets">
      <div class="card">
        <div class="card-title">
          <p class="h4">EVENTO EXCLUSIVO PARA CONVIDADOS</p>
        </div>
        <p class="h6 no-tickets">
          Seu ingresso para este evento é gerado pela organização através da lista de convidados.
        </p>
      </div>
    </div>
  </div>
  } @else if (ticketsSaleBanner) {
  <div class="event-tickets">
    <div class="card-tickets">
      <div class="card tickets-sale-state">
        <div class="card-title">
          <p class="h4">{{ ticketsSaleBanner.title }}</p>
        </div>
        <p class="h6 no-tickets">{{ ticketsSaleBanner.message }}</p>
      </div>
    </div>
  </div>
  } @else if (showTicketPicker) {
  <div class="event-tickets ticket-picker-layout">
    <div class="card-tickets">
      <div class="card ticket-picker">
        <div class="ticket-picker__header">
          <p class="ticket-picker__title">ESCOLHA SEU INGRESSO</p>
          <p class="ticket-picker__subtitle">
            @if (hasComboTickets) {
              Selecione ingressos individuais ou aproveite um combo.
            } @else {
              Selecione os ingressos para este evento.
            }
          </p>
        </div>
        @if (isBatchLoading) {
        <p class="h5 no-tickets">Carregando ingressos</p>
        } @else if (!currentBatch && !hasComboTickets) {
        <p class="h5 no-tickets">Nenhum lote disponível no momento</p>
        } @else {
        @if (currentBatch) {
        <div class="ticket-picker__list">
          @for (ticket of currentBatch.tickets; track ticket.id) {
          <article class="ticket-row">
            <div class="ticket-row__top">
              <div class="ticket-row__heading">
                <span class="ticket-row__title">
                  {{ ticket.title }}
                  @if (ticket.batchNumber) {
                    <span class="ticket-row__lote">LOTE {{ ticket.batchNumber }}</span>
                  }
                  @if (isHalfPriceTicket(ticket)) {
                    <span class="ticket-row__meia">MEIA-ENTRADA</span>
                  }
                </span>
              </div>
              @if (ticketAvailable(ticket)) {
              <div class="qty-stepper">
                <button type="button" class="qty-stepper__btn" (click)="decreaseQuantity(ticket)" aria-label="Diminuir quantidade">
                  <i class="pi pi-minus"></i>
                </button>
                <span class="qty-stepper__value">{{ ticket.addToCartQuantity }}</span>
                <button type="button" class="qty-stepper__btn" (click)="increaseQuantity(ticket)" aria-label="Aumentar quantidade">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
              } @else {
              <app-button styleType="success" [disabled]="true">Esgotado</app-button>
              }
            </div>
            @if (isHalfPriceTicket(ticket)) {
              <button
                class="ticket-row__meia-toggle"
                type="button"
                [attr.aria-expanded]="isHalfPriceRulesExpanded(ticket)"
                (click)="toggleHalfPriceRules(ticket)">
                Ver regras completas de meia-entrada
                <i
                  [class]="isHalfPriceRulesExpanded(ticket) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                  aria-hidden="true"></i>
              </button>
              @if (isHalfPriceRulesExpanded(ticket)) {
                <div class="ticket-row__meia-rules">
                  <p class="ticket-row__meia-rules-title">
                    Para comprar meia-entrada, apresente na compra e na porta um destes documentos:
                  </p>
                  <ul>
                    @for (rule of halfPriceRules(ticket); track rule.key) {
                      <li>
                        <strong>{{ rule.title }}:</strong> {{ rule.proof }}
                      </li>
                    }
                  </ul>
                </div>
              }
            }
            <p class="ticket-row__price">
              <strong>{{ ticket.price | currency: "BRL" }}</strong>
              @if (!currentBatch.absorbs_platform_fee && +ticket.tax > 0) {
                <span>(+ taxa)</span>
              }
            </p>
            <p class="ticket-row__sale-end">
              @if (currentBatch.transition_mode === 'sold_out_only') {
                Até esgotar (limitado ao encerramento do evento)
              } @else {
                Vendas até {{ currentBatch.sale_end | date: "dd/MM/yyyy 'às' HH:mm" }}
              }
            </p>
          </article>
          } @empty {
          <p class="h5 no-tickets">Sem ingressos disponíveis</p>
          }
        </div>
        }
        @if (hasComboTickets) {
        <div class="combo-offers" role="list">
          <p class="combo-offers__heading">COMBOS</p>
          @for (combo of comboTickets; track combo.ticket_id ?? combo.id) {
          <article class="combo-offer" role="listitem">
            <div class="combo-offer__body">
              <div class="combo-offer__heading">
                <i class="pi pi-tags combo-offer__icon" aria-hidden="true"></i>
                <span class="combo-offer__title">
                  {{ combo.title }}
                  <span class="combo-offer__badge">{{ comboBadgeLabel(combo) }}</span>
                </span>
              </div>
              <p class="combo-offer__formula">{{ comboFormula(combo) }}</p>
              <p class="combo-offer__hint">{{ comboTogetherCopy(combo) }}</p>
              <p class="combo-offer__price">
                <strong>{{ combo.price | currency: "BRL" }}</strong>
                @if (!combo.absorbs_platform_fee && +(combo.tax ?? 0) > 0) {
                  <span>+ {{ combo.tax | currency: "BRL" }} taxa</span>
                }
              </p>
              <p class="combo-offer__sale-end">
                @if (combo.sale_end) {
                  Vendas até {{ combo.sale_end | date: "dd/MM/yyyy 'às' HH:mm" }}
                } @else {
                  Até esgotar (limitado ao encerramento do evento)
                }
              </p>
            </div>
            @if (comboAvailable(combo)) {
            <div class="qty-stepper">
              <button type="button" class="qty-stepper__btn" (click)="decreaseComboQuantity(combo)" aria-label="Diminuir quantidade do combo">
                <i class="pi pi-minus"></i>
              </button>
              <span class="qty-stepper__value">{{ combo.addToCartQuantity ?? 0 }}</span>
              <button type="button" class="qty-stepper__btn" (click)="increaseComboQuantity(combo)" aria-label="Aumentar quantidade do combo">
                <i class="pi pi-plus"></i>
              </button>
            </div>
            } @else {
            <app-button styleType="success" [disabled]="true">Esgotado</app-button>
            }
          </article>
          }
        </div>
        }
        }
      </div>
    </div>

    <aside class="event-tickets--sidebar">
      <div class="card purchase-summary">
        <div class="purchase-summary__header">
          <p class="purchase-summary__title">RESUMO DA SUA COMPRA</p>
          <p class="purchase-summary__subtitle">Confira o que está incluído antes de finalizar.</p>
        </div>

        @if (pendingCouponCode) {
          <p class="purchase-summary__coupon" role="status">
            Cupom <strong>{{ pendingCouponCode }}</strong> será vinculado no checkout. Preço abaixo é o valor cheio;
            cupom 0% (comissário) não altera o total.
          </p>
        }

        <div class="purchase-summary__body">
          @for (combo of selectedCombos; track combo.ticket_id ?? combo.id) {
          <article class="summary-combo">
            <div class="summary-combo__top">
              <strong>{{ combo.addToCartQuantity }}× {{ combo.title }}</strong>
              <span>{{ combo.price * (combo.addToCartQuantity ?? 0) | currency: "BRL" }}</span>
            </div>
            @if (combo.component_tickets?.length) {
            <p class="summary-combo__includes-label">Inclui:</p>
            <ul class="summary-combo__includes">
              @for (ticket of combo.component_tickets; track ticket.id) {
              <li>
                {{ ticket.quantity ?? 1 }}
                {{ (ticket.quantity ?? 1) === 1 ? "ingresso" : "ingressos" }}
                {{ ticket.title }}
              </li>
              }
            </ul>
            }
            <p class="summary-combo__note">{{ comboSameComboCopy(combo) }}</p>
          </article>
          }

          @for (ticket of selectedTickets; track ticket.id) {
          <article class="summary-line">
            <strong>{{ ticket.addToCartQuantity }}× {{ ticket.title }}</strong>
            <span>{{ ticket.price * ticket.addToCartQuantity | currency: "BRL" }}</span>
          </article>
          }

          @for (space of selectedSpaces; track space.id ?? space.ticket_id) {
          <article class="summary-line">
            <strong>1× {{ space.title }}</strong>
            <span>{{ space.price + (space.consumption ?? 0) | currency: "BRL" }}</span>
          </article>
          }

          <div class="summary-totals">
            <div class="summary-totals__row">
              <span>Ingressos</span>
              <strong>{{ ticketsSubtotal | currency: "BRL" }}</strong>
            </div>
            <div class="summary-totals__row">
              <span>Taxas</span>
              <strong>{{ taxesSubtotal | currency: "BRL" }}</strong>
            </div>
            <div class="summary-totals__total">
              <div>
                <p>TOTAL</p>
                @if (includedTicketsCount > 0) {
                <small>{{ includedTicketsCount }} {{ includedTicketsCount === 1 ? "ingresso incluído" : "ingressos incluídos" }}</small>
                }
              </div>
              <h2>{{ calcularTotalCompra() | currency: "BRL" }}</h2>
            </div>
          </div>

          <div class="purchase-summary__checkout">
            @if (enableFinishSaleButton()) {
            <app-button (btnClick)="checkIfUserIsLoggedIn()" styleType="success" [disabled]="isCheckoutInProgress"
              [loading]="isCheckoutInProgress">
              {{ finishCheckoutLabel }}
            </app-button>
            } @else {
            <app-button [disabled]="true" styleType="success">{{ finishCheckoutLabel }}</app-button>
            }
          </div>

          @if (comboReceiveCopy) {
          <p class="purchase-summary__receive">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            {{ comboReceiveCopy }}
          </p>
          }

          <div class="card-flags">
            <div class="card-flags-img">
              <img src="./../../../assets/images/bandeiras-cartoes-em-linha.png" alt="bandeiras dos cartões de credito" />
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
  }
  </div>

  <div class="event-overview-layout">
    <div class="event-description">
      <h2>DESCRIÇÃO</h2>
      <div
        class="event-description__content"
        [class.event-description__content--collapsed]="descriptionIsLong && !descriptionExpanded">
        <p class="container-description">{{ eventInfo.description }}</p>
      </div>

      @if (descriptionIsLong) {
      <button class="event-description__toggle" type="button" (click)="toggleDescription()">
        {{ descriptionExpanded ? "MOSTRAR MENOS" : "VER DESCRIÇÃO COMPLETA" }}
        <i [class]="descriptionExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
      </button>
      }
    </div>
  </div>

  @if (eventMapImage || (eventInfo.status === "published" && eventInfo.spaces && eventInfo.spaces.length > 0)) {
  <div class="event-tickets event-experiences">
    @if (eventMapImage) {
    <div class="card event-ticket-map">
      <div class="card-title-clear">
        <p class="h3">MAPA DO EVENTO</p>
      </div>
      <button class="event-ticket-map__expand" type="button" aria-label="Ampliar mapa do evento"
        (click)="openEventMap(eventMapPreview)">
        <img class="event-map" [src]="eventMapImage" alt="Mapa do evento" />
        <span class="event-ticket-map__expand-label">
          <i class="pi pi-search-plus" aria-hidden="true"></i>
          Ampliar mapa
        </span>
      </button>
    </div>
    }

    @if (eventInfo.status === "published" && eventInfo.spaces && eventInfo.spaces.length > 0) {
    <div class="card event-spaces">
      <div class="card-title">
        <p class="h3">CAMAROTES E ÁREAS VIP</p>
      </div>
      <div id="event-spaces-list" class="event-spaces__list" role="list">
        @for (space of visibleSpaces; track space.id) {
        <article class="event-space-card" role="listitem" [attr.aria-labelledby]="'space-title-' + space.id">
          <h3 class="event-space-card__title" [id]="'space-title-' + space.id">{{ space.title }}</h3>
          <p class="event-space-card__capacity">
            <i class="pi pi-users" aria-hidden="true"></i>
            {{ space.quantity }} {{ space.quantity === 1 ? "ingresso incluso" : "ingressos inclusos" }}
          </p>

          @if (space.description && space.description.trim()) {
          <p class="event-space-card__description" [id]="'space-description-' + space.id"
            [class.event-space-card__description--collapsed]="!isSpaceDescriptionExpanded(space)">
            {{ space.description }}
          </p>
          <button class="event-space-card__details-toggle" type="button"
            [attr.aria-controls]="'space-description-' + space.id"
            [attr.aria-expanded]="isSpaceDescriptionExpanded(space)"
            [attr.aria-label]="(isSpaceDescriptionExpanded(space) ? 'Ocultar detalhes de ' : 'Ver detalhes de ') + space.title"
            (click)="toggleSpaceDescription(space)">
            {{ isSpaceDescriptionExpanded(space) ? "Ocultar detalhes" : "Ver detalhes" }}
            <i [class]="isSpaceDescriptionExpanded(space) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" aria-hidden="true"></i>
          </button>
          }

          <div class="event-space-card__purchase">
            <div class="event-space-card__pricing">
              <span class="event-space-card__price-label">Total do espaço</span>
              <strong class="event-space-card__total">{{ spaceTotalPrice(space) | currency: "BRL" }}</strong>
              <p class="event-space-card__breakdown">
                {{ space.price | currency: "BRL" }}
                @if (!space.absorbs_platform_fee && (space.tax ?? 0) > 0) {
                <span class="event-space-card__platform-fee"> + {{ space.tax | currency: "BRL" }} de taxa</span>
                }
                @if (space.consumption && space.consumption > 0) {
                <span class="event-space-card__consumption"> + {{ space.consumption | currency: "BRL" }} de consumação</span>
                }
              </p>
            </div>
            <div class="event-space-card__action">
              @if (spaceInCart(space)) {
              <app-button styleType="outlined" [loading]="isSpaceLoading(space)" (btnClick)="handleRemoveSpace(space)">
                Remover
              </app-button>
              } @else {
              <app-button styleType="success" [disabled]="!spaceAvailable(space)"
                [loading]="isSpaceLoading(space)" (btnClick)="handleAddSpace(space)">
                {{ spaceAvailable(space) ? "Adicionar" : "Esgotado" }}
              </app-button>
              }
            </div>
          </div>
          <p class="event-space-card__sale-end">Vendas até {{ space.sale_end | date: "dd/MM/yyyy 'às' HH:mm" }}</p>
        </article>
        }
      </div>
      @if (spacesAreCollapsible) {
      <div class="event-spaces__footer">
        <p>Exibindo {{ visibleSpaces.length }} de {{ eventInfo.spaces.length }} opções</p>
        <button class="event-spaces__toggle" type="button" aria-controls="event-spaces-list"
          [attr.aria-expanded]="spacesExpanded" (click)="toggleSpaces()">
          {{ spacesExpanded ? "Mostrar menos camarotes" : "Ver todos os camarotes (" + eventInfo.spaces.length + ")" }}
          <i [class]="spacesExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" aria-hidden="true"></i>
        </button>
      </div>
      }
    </div>
    }
  </div>
  }

  <ng-template #eventMapPreview>
    <div class="event-map-preview">
      <div class="event-map-preview__header">
        <h2>Mapa do evento</h2>
        <button mat-icon-button mat-dialog-close type="button" aria-label="Fechar mapa ampliado">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="event-map-preview__content">
        <img [src]="eventMapImage" alt="Mapa ampliado do evento" />
      </div>
    </div>
  </ng-template>

  <div class="row event-sectors">
    <h2>LOCALIZAÇÃO</h2>
    <!-- <img src="./../../../assets/images/home/festival-dj.png" alt="imagem dos lugares e setores do evento" /> -->
    @if (eventMapCenterLocation && isGoogleLoaded) {
    <google-map height="400px" width="100%" [center]="eventMapCenterLocation" [zoom]="15">
      <map-marker [position]="eventMapCenterLocation"></map-marker>
    </google-map>
    }
  </div>
  <!-- <div class="row event-video">
        <iframe
          width="1366"
          height="700"
          src="https://www.youtube.com/embed/Z_gJRWg6gyY?si=v9Ogc8wgYZJIn-xy"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen></iframe>
      </div> -->

  <!-- <div class="row event-point-of-sale">
        <h2>PONTOS DE VENDAS</h2>
        <app-point-of-sale></app-point-of-sale>
      </div> -->

  <div class="row p-3 mt-3 mb-3">
    <app-event-policy />
  </div>
</div>
}
